<div class="dropdown" [ngClass]="componentClass" [class.disabled]="disabled">
  <label *ngIf="label"
    >{{ label | lsTranslate }} <span *ngIf="required">*</span>
  </label>
  <button
    class="o-button o-button--default o-button--medium button__dropdown u-width-100"
    type="button"
    aria-haspopup="true"
    aria-expanded="true"
    (click)="toggle($event)"
    #button
  >
    <span *ngIf="selectedName"> {{ selectedName }} </span>
    <span *ngIf="!selectedName"> {{ placeholder | lsTranslate }} </span>
    <i class="fa fa-caret-down" aria-hidden="true"></i>
  </button>
  <div
    class="dropdown-backdrop"
    *ngIf="panelOpen"
    (click)="toggle($event)"
  ></div>
  <ul
    class="dropdown-menu"
    aria-labelledby="locationDropdown"
    *ngIf="panelOpen"
  >
    <li *ngFor="let item of getItems(); let i = index">
      <a
        href="#"
        #listItem
        class="dropdown-menu-item with-icon"
        (keydown)="handleKeyboardEvent($event.keyCode, $event)"
        (click)="selectAndClose(item, $event)"
        [class.active]="isActive(i)"
        (mouseenter)="selectActive(i)"
      >
        {{ item.name }}
      </a>
    </li>
  </ul>
</div>
